<template>
  
</template>
<script>
export default {
  name: 'TheHeaderDropdownMssgs',
  data () {
    return { itemsCount: 7 }
  }
}
</script>
